import React from "react";
import { DollarSign, TrendingUp, Briefcase } from "lucide-react";
import "./Services.css";
import Footer from "./Footer";
import NavBar from "./NavBar"

const services = [
  {
    icon: DollarSign,
    title: "Debt Financing",
    items: [
      "Trade Finance Solutions",
      "Project Finance Arrangements",
      "Export Credit Facilities",
      "Syndicated Loans",
      "Working Capital Solutions",
    ],
  },
  {
    icon: TrendingUp,
    title: "Equity Financing",
    items: [
      "Private Equity Placements",
      "Venture Capital Sourcing",
      "Strategic Investor Matching",
      "IPO Advisory",
      "Mezzanine Financing",
    ],
  },
  {
    icon: Briefcase,
    title: "Advisory Services",
    items: [
      "Transaction Structuring",
      "Due Diligence Support",
      "Market Entry Strategy",
      "Partnership Facilitation",
      "Risk Assessment",
    ],
  },
];

function Services() {
  return (
    <section id="services" >
      <NavBar/>
      <div className="services-section py-5"> 
      <div className="container text-center" >
        <div className="section-header mb-5">
          <h2 className="fw-bold66 display-6">
            Our <span className="the-color">Services</span>
          </h2>
          <p className="text-muted c634 mt-3">
            Comprehensive financial solutions tailored to the unique needs of African businesses and governments
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div className="service-card" key={index}>
                <div className="stat-icon mb-4">
                  <Icon size={32} className="icon-accent" />
                </div>
                <h4 className="fw-bold mb-3">{service.title}</h4>
                <ul className="list-unstyled text-start">
                  {service.items.map((item, i) => (
                    <li key={i} className="service-item">
                      <span className="bullet">•</span> {item}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
      </div>
      <Footer/>
    </section>
  );
}

export default Services;